import AddToCalendarMobile from '../../components/AddToCalendarMobile/AddToCalendarMobile';
import {connect} from 'react-redux';
import i18nify from '@wix/restaurants-components/dist/shared/I18nify';

function mapStateToProps(state) {
  return {
    reservation: state.reservation.reservation,
    organization: state.organization.organization
  };
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(i18nify(AddToCalendarMobile));



// WEBPACK FOOTER //
// ./containers/AddToCalendarMobile/AddToCalendarMobile.js